import { Link } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  box: {
    background: '#fafafa',
    borderRadius: '4px',
    padding: '20px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    marginBottom: '0',
    gap: '0.375rem',
  },
  boxTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  boxSubtitle: {
    fontSize: '14px',
    opacity: 0.6,
    fontWeight: 400,
    textAlign: 'center',
    width: '100%',
  },
  link: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    color: '#56B26C',
    '& > a': {
      marginLeft: '5px',
    },
  },
});

type SnapshotBoxProps = {
  value: number | string;
  subtitle: string;
  linkTo?: string;
};

export const SnapshotBox = ({ value, subtitle, linkTo }: SnapshotBoxProps) => {
  const { classes } = useStyles();

  return (
    <div className={classes.box}>
      <div className={classes.boxTitle}>{value}</div>
      <div className={classes.boxSubtitle}>{subtitle}</div>
      {linkTo && (
        <Link className={classes.link} to={linkTo}>
          View all
        </Link>
      )}
    </div>
  );
};

export default SnapshotBox;
